import React from "react";
import {Alert, Button, Col} from "react-bootstrap";
import {useSearchParams} from "react-router-dom";
import {DefaultContainer} from "Views/Shared/DefaultContainer";

export const PaymentMethodAuthorize: React.FC = () => {

    const [searchParams] = useSearchParams()
    const result = searchParams.get("result")
    const isSuccess = result === "ok"

    return (
        <DefaultContainer>
            <Col id={"payment-method-authorize"} md={6} className={"mx-md-auto"}>
                <h1 className={"text-center"}>Autorización de Tarjeta</h1>
                <br/>
                {isSuccess ? (
                    <>
                        <Alert variant={"success"} className={"mt-4"}>
                            Tu tarjeta de crédito ha sido registrada correctamente.
                        </Alert>
                    </>
                ) : (
                    <>
                        <Alert variant={"danger"} className={"mt-4"}>
                            No se ha podido registrar la tarjeta de crédito. Por favor, inténtalo de nuevo.
                        </Alert>
                    </>
                )}
                <p>
                    <Button variant={"secondary"} onClick={() => window.close()}>Cerrar ventana</Button>
                </p>
            </Col>
        </DefaultContainer>
    )
}
